import React from 'react';
import './Footer.css';
import logo from '../assets/logo.svg';

const Footer = () => {
  const scrollToSection = (e, sectionId) => {
    e.preventDefault();
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top">
          <div className="footer-brand">
            <a href="#accueil" className="footer-logo" onClick={(e) => scrollToSection(e, 'accueil')}>
              <img src={logo} alt="CPT Express" className="footer-logo-img" />
            </a>
            <p className="footer-tagline">Transport & Placement — Montréal</p>
          </div>
          <div className="footer-links">
            <div className="footer-col">
              <h4>Navigation</h4>
              <ul>
                <li><a href="#accueil" onClick={(e) => scrollToSection(e, 'accueil')}>Accueil</a></li>
                <li><a href="#apropos" onClick={(e) => scrollToSection(e, 'apropos')}>À propos</a></li>
                <li><a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Services</a></li>
                <li><a href="#contact" onClick={(e) => scrollToSection(e, 'contact')}>Contact</a></li>
              </ul>
            </div>
            <div className="footer-col">
              <h4>Services</h4>
              <ul>
                <li><a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Transport express</a></li>
                <li><a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Placement chauffeurs</a></li>
                <li><a href="#services" onClick={(e) => scrollToSection(e, 'services')}>Solutions logistiques</a></li>
              </ul>
            </div>
          </div>
        </div>
        <div className="footer-bottom">
          <p className="footer-copyright">© 2025 CPT Express. Tous droits réservés.</p>
          <div className="footer-social">
            <a href="#" aria-label="LinkedIn">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z"></path>
                <rect x="2" y="9" width="4" height="12"></rect>
                <circle cx="4" cy="4" r="2"></circle>
              </svg>
            </a>
            <a href="#" aria-label="Facebook">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
